import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "app/core";
import { AuthGuard } from "app/users";
import { DashboardComponent } from "app/dashboard";
import { ChooseProfileComponent } from "app/statements/choose-profile/choose-profile.component";
import { PersonalInfoComponent } from "app/statements/personal-info/personal-info.component";
import { ThankYouComponent } from "app/statements/thank-you/thank-you.component";
import { SendCertificateComponent } from "app/statements/send-certificate/send-certificate.component";
import { ClientDetailsComponent } from "app/batches/client-details/client-details.component";
import { CongratulationsComponent } from "app/statements/congratulations/congratulations.component";
import { PaymentCheckoutComponent } from "app/statements/payment-checkout/payment-checkout.component";
import { UpsellPageComponent } from "app/statements/upsell-page/upsell-page.component";
import { ClientSummaryComponent } from "app/batches/client-summary/client-summary.component";
import { ThankYouBusinessComponent } from "app/batches/thank-you-business/thank-you-business.component";
import { CongratulationsBusinessComponent } from "app/batches/congratulations-business/congratulations-business.component";
import { PaymentAbortComponent } from "app/payment/payment-abort/payment-abort.component";
import { PaymentTimeOutComponent } from "app/payment/payment-time-out/payment-time-out.component";
import { PackageSelectionComponent } from "app/statements/package-selection/package-selection.component";
import { DownloadStatementComponent } from "app/statements/download-statement/download-statement.component";
import { FinishComponent } from "app/statements/finish/finish.component";
import { VollmachtAuthorizationComponent } from "app/statements/vollmacht-authorization/vollmacht-authorization.component";
import { TaxDocumentsComponent } from "app/statements/tax-documents/tax-documents.component";
import { ActivationComponent } from "app/core/activation/activation.component";
import { AdditionalIncomeOptionsComponent } from "app/statements/additional-income-options/additional-income-options.component";
import { BankDetailComponent } from "app/statements/bank-detail/bank-detail.component";
import { TaxAdvisorAdditionalValidationComponent } from "app/statements/tax-advisor-additional-validation/tax-advisor-additional-validation.component";
import { ConfirmTaxReturnComponent } from "app/statements/confirm-tax-return/confirm-tax-return.component";
import { ConfirmNewPremiumPriceComponent } from "app/statements/confirm-new-premium-price/confirm-new-premium-price.component";
import { B2bAbroadIncomeInfoComponent } from "app/statements/b2b-abroad-income-info/b2b-abroad-income-info.component";
import { TaxCardComponentPath } from "app/core/workflow/page-path/statement-page-path/tax-card-component.path";
import { B2bTaxCardComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.tax-card-component.path";
import { TaxCardComponent } from "app/statements/tax-card/tax-card.component";
import { TaxCardSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/tax-card-spouse-component.path";
import { B2bTaxCardSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.tax-card-spouse-component.path";
import { BankDetailComponentPath } from "app/core/workflow/page-path/statement-page-path/bank-detail-component.path";
import { B2bAbroadIncomeComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.abroad-income-component.path";
import { AdditionalIncomeSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/additional-income-spouse-component.path";
import { PersonalInfoComponentPath } from "app/core/workflow/page-path/statement-page-path/personal-info-component.path";
import { PersonalInfoSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/personal-info-spouse-component.path";
import { PaymentExecutionComponent } from "app/payment/payment-execution/payment-execution.component";
import { PaymentConfirmationComponent } from "app/payment/payment-confirmation/payment-confirmation.component";
import { PaymentHistoryComponent } from "app/payment/payment-history/payment-history.component";
import { PackageListComponent } from "app/payment/package-list/package-list.component";
import { PaymentCheckoutComponentPath } from "app/core/workflow/page-path/statement-page-path/payment-checkout-component.path";
import { UpsellPageComponentPath } from "app/core/workflow/page-path/statement-page-path/upsell-page-component.path ";
import { PackageSelectionComponentPath } from "app/core/workflow/page-path/statement-page-path/package-selection-component.path";
import { PhoneVerificationComponentPath } from "app/core/workflow/page-path/statement-page-path/phone-verification-component.path";
import { VollmachtAuthorizationComponentPath } from "app/core/workflow/page-path/statement-page-path/vollmacht-authorization-component.path";
import { TaxDocumentsComponentPath } from "app/core/workflow/page-path/statement-page-path/tax-documents-component.path";
import { ThankYouComponentPath } from "app/core/workflow/page-path/statement-page-path/thank-you-component.path";
import { SendCertificateComponentPath } from "app/core/workflow/page-path/statement-page-path/send-certificate.path";
import { B2cAdditionalIncomePage } from "app/modules/statement/pages/b2c.additional-income/b2c.additional-income.page";
import { NgModule } from "@angular/core";
import { FinishPagePath } from "app/core/workflow/page-path/statement-page-path/finish-page.path";
import { DashboardPagePath } from "app/core/workflow/page-path/dashboard-page.path";
import { ActivatePagePath } from "app/core/workflow/page-path/activate-page.path";
import { StarterBoardPage } from "app/core/pages/starter-board-page/starter-board.page";
import { RateAppPagePath } from "app/core/workflow/page-path/rate-app-page.path";
import { DeductionSkipComponentPath } from "app/core/workflow/page-path/statement-page-path/deduction-skip-component.path";
import { DeductionInfoSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/deduction-info-spouse-component.path";
import { DeductionInfoChildComponentPath } from "app/core/workflow/page-path/statement-page-path/deduction-info-child-component.path";
import { DeductionInfoComponentPath } from "app/core/workflow/page-path/statement-page-path/deduction-info-component.path";
import { B2bDeductionInfoComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.deduction-info-component.path";
import { B2bDeductionInfoSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.deduction-info-spouse-component.path";
import { B2bDeductionInfoChildComponentPath } from "app/core/workflow/page-path/statement-page-path/b2b.deduction-info-child-component.path";
import { TermsAndConditionsPagePath } from "app/core/workflow/page-path/terms-and-conditions-page.path";
import { PrivacyPolicyPagePath } from "app/core/workflow/page-path/privacy-policy-page.path";
import { CouponsPagePath } from "app/core/workflow/page-path/coupons.path";
import { ThankYouRedirectComponent } from "app/standalone-pages/thank-you-redirect/thank-you-redirect.component";
import { IdentityVerificationComponent } from "app/statements/identity-verification/identity-verification.component";
import { IdentityVerificationComponentPath } from "app/core/workflow/page-path/statement-page-path/identity-verification-component.path";
import { UserProfilePagePath } from "app/core/workflow/page-path/user-profile.path";
import { ContractWithdrawalPagePath } from "app/core/workflow/page-path/contract-withdrawal-page.path";
import { NewsletterResignationInfoPath } from "app/core/workflow/page-path/newsletter-resignation-info-page.path";
import { NewsletterResignationInfoComponent } from "app/core/newsletter-update/newsletter-resignation-info.component";
import { ConfirmNewPremiumComponentPath } from "app/core/workflow/page-path/statement-page-path/confirm-new-premium-price.path";
const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "new",
    pathMatch: "full"
  },
  {
    path: RateAppPagePath.path(),
    loadChildren: () => import("app/modules/rateapp/rateapp.module").then((m) => m.RateappModule)
  },
  {
    path: "premium-payment-completed",
    loadChildren: () => import("app/modules/rateapp/rateapp.module").then((m) => m.RateappModule)
  },
  {
    path: "premium-payment/:token",
    loadComponent: () =>
      import("app/standalone-pages/premium-payment/premium-payment.page").then((c) => c.PremiumPaymentPage)
  },
  {
    path: "disable-analytics",
    loadChildren: () =>
      import("app/modules/disable-analytics/disable-analytics.module").then((m) => m.DisableAnalyticsModule)
  },
  {
    path: PrivacyPolicyPagePath.path(),
    loadComponent: () =>
      import("app/standalone-pages/privacy-policy/privacy-policy.component").then((c) => c.PrivacyPolicyComponent)
  },
  {
    path: CouponsPagePath.path(),
    loadComponent: () => import("app/standalone-pages/coupons/coupons.page").then((c) => c.CouponsPage)
  },
  {
    path: UserProfilePagePath.path(),
    loadComponent: () =>
      import("app/standalone-pages/user-profile/user-profile.page").then((c) => c.UserProfilePageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ContractWithdrawalPagePath.path(),
    loadComponent: () =>
      import("app/standalone-pages/contract-withdrawal/contract-withdrawal.page").then((c) => c.ContractWithdrawalPage),
    canActivate: [AuthGuard]
  },
  {
    path: TermsAndConditionsPagePath.path(),
    loadComponent: () =>
      import("app/standalone-pages/terms-and-conditions/terms-and-conditions.component").then(
        (c) => c.TermsAndConditionsComponent
      )
  },
  {
    path: "new",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: StarterBoardPage
      },
      {
        path: "statement/:statementId",
        children: [
          ...ThankYouRedirectComponent.processingEndpoints.map((endpoint) => ({
            path: endpoint,
            component: ThankYouRedirectComponent
          })),
          ...ThankYouRedirectComponent.processingEndpoints.map((endpoint) => ({
            path: `paypal/${endpoint}`,
            component: ThankYouRedirectComponent
          }))
        ]
      },
      {
        path: B2bTaxCardComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2b-tax-card/b2b.tax-card.page").then((c) => c.B2bTaxCardPage),
        canActivate: [AuthGuard]
      },
      {
        path: B2bTaxCardSpouseComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2b-tax-card/b2b.tax-card.page").then((c) => c.B2bTaxCardPage),
        canActivate: [AuthGuard]
      },
      {
        path: DeductionSkipComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2c.deduction-skip/b2c.deduction-skip.page").then((c) => c.B2cDeductionSkipPage),
        canActivate: [AuthGuard]
      },
      {
        path: DeductionInfoSpouseComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2c.deduction-info/b2c.deduction-info.page").then((c) => c.B2cDeductionInfoPage),
        canActivate: [AuthGuard]
      },
      {
        path: DeductionInfoChildComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2c.deduction-info/b2c.deduction-info.page").then((c) => c.B2cDeductionInfoPage),
        canActivate: [AuthGuard]
      },
      {
        path: DeductionInfoComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2c.deduction-info/b2c.deduction-info.page").then((c) => c.B2cDeductionInfoPage),
        canActivate: [AuthGuard]
      },
      {
        path: B2bDeductionInfoComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2b.deduction-info/b2b.deduction-info.page").then((c) => c.B2bDeductionInfoPage),
        canActivate: [AuthGuard]
      },
      {
        path: B2bDeductionInfoSpouseComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2b.deduction-info/b2b.deduction-info.page").then((c) => c.B2bDeductionInfoPage),
        canActivate: [AuthGuard]
      },
      {
        path: B2bDeductionInfoChildComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/b2b.deduction-child-info/b2b.deduction-child-info.page").then(
            (c) => c.B2bDeductionChildInfoPage
          ),
        canActivate: [AuthGuard]
      },
      {
        path: TaxCardComponentPath.path(),
        component: TaxCardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: TaxCardSpouseComponentPath.path(),
        component: TaxCardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: B2bAbroadIncomeComponentPath.path(),
        component: B2bAbroadIncomeInfoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/profile",
        component: ChooseProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "",
        loadChildren: () => import("app/modules/statement/statement.module").then((m) => m.StatementModule),
        canActivate: [AuthGuard]
      },
      {
        path: PersonalInfoComponentPath.path(),
        component: PersonalInfoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: AdditionalIncomeSpouseComponentPath.path(),
        component: B2cAdditionalIncomePage,
        canActivate: [AuthGuard]
      },
      {
        path: PersonalInfoSpouseComponentPath.path(),
        component: PersonalInfoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: BankDetailComponentPath.path(),
        component: BankDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: PackageSelectionComponentPath.path(),
        component: PackageSelectionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: PhoneVerificationComponentPath.path(),
        loadComponent: () =>
          import("app/standalone-pages/phone-verification/phone-verification.component").then(
            (c) => c.PhoneVerificationComponent
          ),
        canActivate: [AuthGuard]
      },
      {
        path: ThankYouComponentPath.pathWithHash(),
        component: ThankYouComponent,
        canActivate: [AuthGuard]
      },
      {
        path: IdentityVerificationComponentPath.path(),
        component: IdentityVerificationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: ThankYouComponentPath.path(),
        component: ThankYouComponent,
        canActivate: [AuthGuard]
      },
      {
        path: SendCertificateComponentPath.path(),
        component: SendCertificateComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/confirm-tax-return",
        component: ConfirmTaxReturnComponent,
        canActivate: [AuthGuard]
      },
      {
        path: ConfirmNewPremiumComponentPath.path(),
        component: ConfirmNewPremiumPriceComponent,
        canActivate: [AuthGuard]
      },
      {
        path: UpsellPageComponentPath.path(),
        component: UpsellPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: PaymentCheckoutComponentPath.path(),
        component: PaymentCheckoutComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/congratulations",
        component: CongratulationsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/payment-execute",
        component: PaymentExecutionComponent
      },
      {
        path: FinishPagePath.path(),
        component: FinishComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "batch/:batchId/client-details",
        component: ClientDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "batch/:batchId/client-summary",
        component: ClientSummaryComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "batch/:batchId/payment-execute",
        component: PaymentExecutionComponent
      },
      {
        path: "batch/:batchId/thank-you",
        component: ThankYouBusinessComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "batch/:batchId/congratulations",
        component: CongratulationsBusinessComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/download-statement",
        component: DownloadStatementComponent,
        canActivate: [AuthGuard]
      },
      {
        path: VollmachtAuthorizationComponentPath.path(),
        component: VollmachtAuthorizationComponent
      },
      {
        path: TaxDocumentsComponentPath.path(),
        component: TaxDocumentsComponent
      },
      {
        path: "statement/:statementId/tax-advisor-additional-validation",
        component: TaxAdvisorAdditionalValidationComponent
      },
      {
        path: "statement/:statementId/spouse/:spouseId/additional-options/:step",
        component: AdditionalIncomeOptionsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/spouse/:spouseId/additional-options",
        component: AdditionalIncomeOptionsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/additional-options/:step",
        component: AdditionalIncomeOptionsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statement/:statementId/additional-options",
        component: AdditionalIncomeOptionsComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "login",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: StarterBoardPage,
        data: {
          openedDialog: "login"
        }
      }
    ]
  },
  {
    path: "register",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: StarterBoardPage,
        data: {
          openedDialog: "register"
        }
      }
    ]
  },
  {
    path: "forgot-password",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: StarterBoardPage,
        data: {
          openedDialog: "forgot"
        }
      }
    ]
  },
  {
    path: "",
    loadChildren: () => import("app/modules/user/user.module").then((m) => m.UserModule)
  },
  {
    path: "password/reset",
    loadChildren: () =>
      import("app/modules/user/modules/reset-password/reset-password.module").then((m) => m.ResetPasswordModule)
  },
  {
    path: DashboardPagePath.path(),
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "dashboard/:year/:yearid",
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "packages",
    component: PackageListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "payment-history",
    component: PaymentHistoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ActivatePagePath.path(),
    component: ActivationComponent
  },
  {
    path: NewsletterResignationInfoPath.path(),
    component: NewsletterResignationInfoComponent
  },
  // Without AuthGuard because user can be logged out when he is redirected:
  {
    path: "payment-confirmation",
    component: PaymentConfirmationComponent
  },
  {
    path: "payment-execute",
    component: PaymentExecutionComponent
  },
  {
    path: "payment-timeout",
    component: PaymentTimeOutComponent
  },
  {
    path: "payment-abort/:statementId",
    component: PaymentAbortComponent
  },
  {
    path: "payment-abort",
    component: PaymentAbortComponent
  },
  {
    path: "**",
    redirectTo: "/new"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
